import { makeAutoObservable } from 'mobx'

import { ChatbotStatus, type IChatbotBase } from './type'

export class ChatbotListItem {
  id = 0
  name = ''
  status = ChatbotStatus.Draft
  totalContacts = 0
  fallbackContacts = 0
  completedContacts = 0
  terminatedContacts = 0
  type = 0
  updatedAt = ''

  constructor(public origin: IChatbotBase) {
    this.syncOrigin(origin)
    makeAutoObservable(this)
  }

  get isDraft() {
    return this.status === ChatbotStatus.Draft
  }

  get isDisabled() {
    return this.status === ChatbotStatus.Disabled
  }

  get isActive() {
    return this.status === ChatbotStatus.Active
  }

  get isInvalid() {
    return this.status === ChatbotStatus.Invalid
  }

  syncOrigin(origin: IChatbotBase) {
    this.origin = origin
    this.id = origin.id
    this.name = origin.name
    this.status = origin.status
    this.totalContacts = origin.total_contacts_count
    this.fallbackContacts = origin.fallback_contacts_count
    this.completedContacts = origin.completed_contacts_count
    this.terminatedContacts = origin.terminated_contacts_count
    this.type = origin.type
    this.updatedAt = origin.updated_at
  }
}
